var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{ noPadding: _vm.$route.path.indexOf('/record') > -1, inApp: _vm.$root.$data.isApp }},[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('BrowseTime'),_c('BrowseTask')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }